import { SalesGeneratedCard_MetaSumInsightsFragment } from '@frontend/gql/social/graphql';
import { formatCurrency } from '../../../../../utils/formatCurrency';

export const calculateSpendMetrics = ({
  currentInterval,
  previousInterval,
  currentIntervalNotAspireSourced,
}: {
  currentInterval: SalesGeneratedCard_MetaSumInsightsFragment | null | undefined;
  previousInterval: SalesGeneratedCard_MetaSumInsightsFragment | null | undefined;
  currentIntervalNotAspireSourced: SalesGeneratedCard_MetaSumInsightsFragment | null | undefined;
}): {
  formattedCurrentInterval: string | number | null | undefined;
  formattedCurrentIntervalNotAspireSourced: string | number | null | undefined;
  percentChange: number | 'NA' | 'Infinity';
} => {
  const currentIntervalAmount = currentInterval?.totalPurchase?.amount ?? 0;
  const currency = currentInterval?.totalPurchase?.currency;
  const previousIntervalAmount = previousInterval?.totalPurchase?.amount ?? 0;

  // Use formatCurrency for all values including zero to ensure proper currency formatting
  const formattedCurrentInterval = formatCurrency(currentIntervalAmount, currency || 'USD');

  const currentIntervalNotAspireSourcedAmount = currentIntervalNotAspireSourced?.totalPurchase?.amount ?? 0;

  // Use formatCurrency for all values including zero to ensure proper currency formatting
  const formattedCurrentIntervalNotAspireSourced = formatCurrency(
    currentIntervalNotAspireSourcedAmount,
    currency || 'USD',
  );
  // calculate the percent change from previous month
  let percentChange: number | 'NA' | 'Infinity';

  if (previousInterval?.totalPurchase?.amount == null) {
    // Previous data is null/undefined
    percentChange = 'NA';
  } else if (previousIntervalAmount === 0) {
    // Transition from 0 to any value
    percentChange = currentIntervalAmount > 0 ? 'Infinity' : 'NA';
  } else {
    // Normal percent change calculation
    percentChange = ((currentIntervalAmount - previousIntervalAmount) / previousIntervalAmount) * 100;
  }

  return {
    formattedCurrentInterval,
    formattedCurrentIntervalNotAspireSourced,
    percentChange,
  };
};
